import React, { useEffect, useState } from "react"
import { Alert, Modal, ModalBody, ModalHeader, Spinner, Table } from "reactstrap"
import moment from "moment"
import { getMustReadVersions } from "helpers/mustReadApi"

const formatPublishedAt = (iso) => (iso ? moment(iso).format("MMM D, YYYY h:mm A") : "—")

const contentLabel = (documentName, contentType) => {
  if (documentName) return documentName
  return contentType === "html" ? "HTML" : "File unavailable"
}

const MustReadVersionHistoryModal = ({ isOpen, itemId, title, contentType, onClose }) => {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!isOpen || !itemId) return undefined
    let cancelled = false
    setLoading(true)
    setError(null)
    setItems([])
    getMustReadVersions(itemId)
      .then((data) => {
        if (!cancelled) setItems(data?.items || [])
      })
      .catch(() => {
        if (!cancelled) setError("Could not load version history.")
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [isOpen, itemId])

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="xl">
      <ModalHeader toggle={onClose}>Version history{title ? `: ${title}` : ""}</ModalHeader>
      <ModalBody>
        {loading && (
          <div className="text-center p-4">
            <Spinner />
          </div>
        )}
        {error && (
          <Alert color="danger" fade={false}>
            {error}
          </Alert>
        )}
        {!loading && !error && items.length === 0 && (
          <div className="text-muted">No versions published yet.</div>
        )}
        {!loading && !error && items.length > 0 && (
          <Table responsive hover className="align-middle mb-0">
            <thead>
              <tr>
                <th>Version</th>
                <th>Published</th>
                <th>By</th>
                <th>What changed</th>
                <th>Re-review required</th>
                <th>Content</th>
              </tr>
            </thead>
            <tbody>
              {items.map((v) => (
                <tr key={v.id}>
                  <td>
                    v{v.versionNumber}
                    {v.isCurrent && <span className="mr-tag ms-1">Current</span>}
                  </td>
                  <td>{formatPublishedAt(v.publishedAt)}</td>
                  <td>{v.publishedBy || "—"}</td>
                  <td>{v.changeNote || "—"}</td>
                  <td>{v.requiresReview ? "Yes" : "No"}</td>
                  <td>{contentLabel(v.documentName, contentType)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
    </Modal>
  )
}

export default MustReadVersionHistoryModal
